import React from 'react'
import { Button } from '@/components/ui/button'
import { type UIChoice } from '../types/chat-model'
import { cn } from '@/lib/utils'

interface MessageChoicesProps {
    choices: UIChoice[]
    className?: string
    buttonClassName?: string
    mode?: 'chat' | 'galgame'
}

/**
 * 消息选项组件
 * 样式：选项宽度同宽（以最宽为准），支持响应式布局
 */
export const MessageChoices: React.FC<MessageChoicesProps> = ({
    choices,
    className,
    buttonClassName,
    mode = 'chat',
}) => {
    if (!choices || choices.length === 0) return null

    // 根据模式决定背景透明度
    const bgStyle =
        mode === 'galgame'
            ? 'bg-background/95 dark:bg-zinc-900/95 shadow-2l' // Galgame 模式：更高不透明度，增强对比
            : 'bg-background/50 hover:bg-primary/5' // 普通模式：半透明

    return (
        <div className={cn('flex w-full flex-col items-center justify-center gap-3 px-2', className)}>
            <div className='flex w-full max-w-[90%] flex-col items-stretch gap-2.5 md:w-fit md:min-w-[40%]'>
                {choices.map((choice) => (
                    <Button
                        key={choice.id}
                        variant='outline'
                        onClick={(e) => {
                            // 阻止冒泡，防止触发父容器的点击事件（例如 Galgame 模式的屏幕点击）
                            e.stopPropagation()
                            choice.action?.()
                        }}
                        className={cn(
                            'animate-in fade-in slide-in-from-bottom-2 border-primary/20 hover:border-primary hover:text-primary h-auto px-4 py-3.5 text-center text-[14px] font-medium tracking-wide wrap-break-word whitespace-normal transition-all md:text-base',
                            bgStyle,
                            buttonClassName
                        )}
                    >
                        {choice.text}
                    </Button>
                ))}
            </div>
        </div>
    )
}
